import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedIncomingSecurity = mutatorAction('updateAdvancedIncomingSecurity', function (incomingSecurity) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.incomingSecurity = incomingSecurity;
});
//# sourceMappingURL=updateAdvancedIncomingSecurity.js.map